/* lkp2-share.js - shareable design link + downloadable preview image. Add-on for the personaliser (no engine edits). */
(function () {
  'use strict';
  var HASH = '#lk=';
  function inst() { return window.LKP2 && window.LKP2.get && window.LKP2.get(); }
  function b64e(s) { return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function b64d(s) { s = s.replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '='; return decodeURIComponent(escape(atob(s))); }
  function propsObj(p) { var o = {}; p.props().forEach(function (kv) { o[kv[0]] = kv[1]; }); return o; }
  function makeLink(p) {
    var data = { v: p.variant && p.variant.id || null, p: propsObj(p) };
    return location.origin + location.pathname + HASH + b64e(JSON.stringify(data));
  }
  function flash(btn, txt) {
    var keep = btn.getAttribute('data-keep') || btn.textContent; btn.setAttribute('data-keep', keep);
    btn.textContent = txt; clearTimeout(btn._t); btn._t = setTimeout(function () { btn.textContent = keep; }, 2200);
  }
  function copyText(t) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(t);
    return new Promise(function (res, rej) {
      var ta = document.createElement('textarea'); ta.value = t; ta.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy') ? res() : rej(); } catch (e) { rej(e); } ta.remove();
    });
  }
  function onShare(p, btn) {
    var url = makeLink(p), title = (p.product && p.product.title || 'My design') + ' - Lush Keepsake';
    if (navigator.share && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
      navigator.share({ title: title, text: 'Have a look at my design', url: url }).catch(function () {});
      return;
    }
    copyText(url).then(function () { flash(btn, 'Link copied'); }, function () { window.prompt('Copy your design link:', url); });
  }
  /* Draw every side that has wording onto one PNG */
  function onDownload(p, btn) {
    var faces = p.faces().filter(function (f) { return p.drawable(f) && p.hasContent(f); });
    if (!faces.length) faces = p.faces().filter(function (f) { return p.drawable(f); }).slice(0, 1);
    if (!faces.length) { flash(btn, 'Nothing to download yet'); return; }
    var W = 1200, H = 900, cap = 90, cvs = [];
    flash(btn, 'Preparing...');
    var run = faces.reduce(function (pr, f) {
      return pr.then(function () {
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        return p.render(cv, f, 'full', { dpr: 1, again: false }).then(function () { cvs.push({ cv: cv, label: f.label }); });
      });
    }, Promise.resolve());
    run.then(function () {
      var out = document.createElement('canvas'); out.width = W; out.height = (H + cap) * cvs.length;
      var x = out.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, out.width, out.height);
      cvs.forEach(function (c, i) {
        var y = i * (H + cap);
        x.drawImage(c.cv, 0, y);
        x.fillStyle = '#1F1C18'; x.textBaseline = 'middle';
        x.font = '600 30px Georgia, serif'; x.fillText((p.product && p.product.title || '') + (cvs.length > 1 ? ' - ' + c.label : ''), 40, y + H + 34);
        x.fillStyle = '#5C564D'; x.font = '22px Georgia, serif';
        x.fillText('Preview only. Lush Keepsake checks every engraving before it goes out.', 40, y + H + 68);
      });
      out.toBlob(function (b) {
        if (!b) { flash(btn, 'Could not create image'); return; }
        var a = document.createElement('a'), name = ((p.product && p.product.handle) || 'my-design') + '-preview.png';
        a.href = URL.createObjectURL(b); a.download = name; document.body.appendChild(a); a.click();
        setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1500);
        flash(btn, 'Downloaded');
      }, 'image/png');
    }).catch(function () { flash(btn, 'Could not create image'); });
  }
  function addButtons(p) {
    if (!p.secReview || !p.elSummary || p.secReview.querySelector('.lkp2__share')) return;
    var st = document.createElement('style');
    st.textContent = '.lkp2__share{display:flex;gap:8px;margin:14px 0 4px;flex-wrap:wrap}.lkp2__share button{flex:1 1 150px;min-height:44px;padding:8px 12px;border:1px solid var(--lk-line,#E7E1D7);background:#fff;color:var(--lk-ink,#1F1C18);border-radius:2px;font:inherit;font-size:14px;cursor:pointer}.lkp2__share button:hover{border-color:var(--lk-accent,#9C7F4E)}';
    document.head.appendChild(st);
    var d = document.createElement('div'); d.className = 'lkp2__share';
    d.innerHTML = '<button type="button" data-share>Copy design link</button><button type="button" data-dl>Download preview</button>';
    p.elSummary.parentNode.insertBefore(d, p.elSummary.nextSibling);
    d.querySelector('[data-share]').onclick = function () { onShare(p, this); };
    d.querySelector('[data-dl]').onclick = function () { onDownload(p, this); };
  }
  /* open a shared design: variant first, then the wording */
  function restore(p) {
    var m = location.hash.indexOf(HASH) === 0 ? location.hash.slice(HASH.length) : null;
    if (!m) return;
    var data; try { data = JSON.parse(b64d(m)); } catch (e) { return; }
    if (!data || typeof data.p !== 'object') return;
    var go = function () { p.prefill(data.p); p.open(); };
    if (data.v && p.selectVariant) p.selectVariant(data.v, go); else go();
  }
  var tries = 0;
  (function wait() {
    var p = inst();
    if (p && p.cfg && p.secReview) { addButtons(p); restore(p); return; }
    if (p && p.cfg && p.finishOnly) return;
    if (tries++ < 60) setTimeout(wait, 250);
  })();
})();
